export class GlueSyncScope {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mode",
            "baseName": "mode",
            "type": "GlueSyncScopeMode",
            "format": ""
        },
        {
            "name": "databases",
            "baseName": "databases",
            "type": "Array<GlueDatabaseSelection>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GlueSyncScope.attributeTypeMap;
    }
    constructor() {
    }
}
